import { render, staticRenderFns } from "./ManageProductization.vue?vue&type=template&id=927f040c"
import script from "./ManageProductization.vue?vue&type=script&lang=js"
export * from "./ManageProductization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927f040c')) {
      api.createRecord('927f040c', component.options)
    } else {
      api.reload('927f040c', component.options)
    }
    module.hot.accept("./ManageProductization.vue?vue&type=template&id=927f040c", function () {
      api.rerender('927f040c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/ManageProductization.vue"
export default component.exports